import React from "react";

function SkeletonCard() {
  return (
    <div className="rounded-[1.5rem] border border-slate-200 bg-slate-50 p-4 dark:border-white/10 dark:bg-white/[0.04]">
      <div className="flex items-start gap-3">
        <div className="h-11 w-11 animate-pulse rounded-2xl bg-slate-200 dark:bg-white/10" />

        <div className="flex-1">
          <div className="h-6 w-2/3 animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />
          <div className="mt-3 h-4 w-full animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />
          <div className="mt-2 h-4 w-3/4 animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />
        </div>
      </div>
    </div>
  );
}

function LexiqueSkeleton() {
  return (
    <div className="mt-6 overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-slate-900 dark:shadow-black/20">
      <div className="flex items-center gap-3 border-b border-slate-200 bg-slate-50 p-5 dark:border-white/10 dark:bg-white/[0.03]">
        <div className="h-12 w-12 animate-pulse rounded-2xl bg-slate-200 dark:bg-white/10" />
        <div>
          <div className="h-4 w-24 animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />
          <div className="mt-3 h-7 w-48 animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />
        </div>
      </div>

      <div className="grid gap-3 p-4 sm:p-5 md:grid-cols-2 xl:grid-cols-3">
        <SkeletonCard />
        <SkeletonCard />
        <SkeletonCard />
        <SkeletonCard />
        <SkeletonCard />
        <SkeletonCard />
        <SkeletonCard />
        <SkeletonCard />
        <SkeletonCard />
      </div>
    </div>
  );
}

export default LexiqueSkeleton;